import React from 'react';
import { Tabs } from '../../../../Components/Tabs/Tabs';
import { LeaderboardTable } from '../../../Leaderboard/components/LeaderboardTable/LeaderboardTable';
import { ModalLoader } from '../../../../Components/ModalLoader';
import { ResultsTab } from '../../types';
import { useResultsContent } from '../../hooks/useResultsContent';
import './ResultsContent.scss';

interface ResultsContentProps {
  selectedChallenge?: string;
}

const RESULTS_TABS = [
  { id: 'participants' as ResultsTab, label: 'Participants' },
  { id: 'areas' as ResultsTab, label: 'Areas' },
  { id: 'offices' as ResultsTab, label: 'Offices' },
];

const getColumns = (activeTab: ResultsTab) => {
  if (activeTab === 'participants') {
    return [
      { id: 'rank', label: 'Rank', width: '10%' },
      { id: 'participant', label: 'Name', width: '70%' },
      { id: 'area', label: 'Area', width: '20%' },
    ];
  }
  if (activeTab === 'areas') {
    return [
      { id: 'rank', label: 'Rank', width: '10%' },
      { id: 'area', label: 'Area', width: '70%' },
      {
        id: 'score',
        label: 'Score',
        width: '20%',
        render: (row: any) => <span className="score-value">{row.score} points</span>,
      },
    ];
  }
  return [
    { id: 'rank', label: 'Rank', width: '10%' },
    { id: 'office', label: 'Office', width: '70%' },
    {
      id: 'score',
      label: 'Score',
      width: '20%',
      render: (row: any) => <span className="score-value">{row.score} points</span>,
    },
  ];
};

export const ResultsContent: React.FC<ResultsContentProps> = ({ selectedChallenge }) => {
  const selectedEventId = selectedChallenge ? parseInt(selectedChallenge) : 1;
  const {
    activeTab,
    currentData,
    totalPages,
    currentPage,
    myParticipant,
    isLoading,
    handleTabChange,
    handlePageChange,
  } = useResultsContent(selectedEventId);

  return (
    <div className="results-content">
      <div className="results-header-controls">
        <Tabs<ResultsTab> tabs={RESULTS_TABS} activeTab={activeTab} onTabChange={handleTabChange} />
      </div>

      <div className="results-table">
        {isLoading ? (
          <ModalLoader />
        ) : (
          <LeaderboardTable
            columns={getColumns(activeTab)}
            data={currentData}
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            getRowClassName={(row) => {
              if (activeTab !== 'participants') return '';
              const match = Boolean(myParticipant && row.id === myParticipant.id);
              return match ? 'your-position' : '';
            }}
            emptyMessage={
              activeTab === 'participants'
                ? 'No participants found'
                : activeTab === 'areas'
                  ? 'No areas found'
                  : 'No offices found'
            }
          />
        )}
      </div>
    </div>
  );
};
